import { Logo } from '@/components/common';
import {
  SidebarHeader as SidebarHeaderPrimitive,
  SidebarTrigger,
} from '@/components/ui/sidebar';
import { useTranslation } from '@/hooks/useTranslation';

export const SidebarHeader = () => {
  const { t } = useTranslation();

  return (
    <SidebarHeaderPrimitive>
      {/* Collapse/expand toggle, top-right of the sidebar. Stays reachable in
          icon mode (sidebar shrinks to a rail rather than disappearing). */}
      <div className='flex justify-end group-data-[collapsible=icon]:justify-center'>
        <SidebarTrigger aria-label={t('navigation.toggleSidebar')} />
      </div>
      <div className='flex flex-col items-center space-y-3 px-6 py-4 group-data-[collapsible=icon]:hidden'>
        <Logo size='lg' />
        <h2 className='text-xs font-semibold text-sidebar-foreground text-center'>
          {t('company.name')}
        </h2>
      </div>
    </SidebarHeaderPrimitive>
  );
};
